import { render, staticRenderFns } from "./PortraitDetailDialog.vue?vue&type=template&id=34e54255&"
import script from "./PortraitDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PortraitDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PortraitDetailDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports